(() => {
    const getCurrencyFormatter = (() => {
        let formatter;

        return () => {
            const locale = `en-${Shopify?.country || "HK"}`;

            return (
                formatter ??= new Intl.NumberFormat(locale, {
                    style: "currency",
                    currency: Shopify?.currency?.active || "HKD",
                    currencyDisplay: "narrowSymbol",
                })
            );
        };
    })();

    const shopifyMoneyFormat = (amount) => {
        if (typeof Shopify?.formatMoney !== "function") {
            return null;
        }

        const moneyFormat =
            window.theme?.moneyFormat ||
            Shopify?.money_format ||
            "${{amount}}";

        return Shopify.formatMoney(amount, moneyFormat);
    };

    const formatMoney = (amount) => {
        return (
            shopifyMoneyFormat(amount) ??
            getCurrencyFormatter().format(amount / 100)
        );
    };

    window.Utils = {
        formatMoney,
        shopifyMoneyFormat,
        getCurrencyFormatter
    };
})();